<template>
  <div class="px-3" data-test="sidebar-ricerca">
    <UiInput
      ref="campo"
      v-model="testo"
      type="search"
      size="sm"
      icon="fal fa-search"
      :placeholder="t('layout.menu.cerca')"
      :aria-label="t('layout.menu.cerca_nel_menu')"
      autocomplete="off"
      spellcheck="false"
      @keydown.escape.stop="testo = ''"
      @keydown.enter.prevent="emit('invio')"
    >
      <template #trailing>
        <kbd class="shrink-0 rounded border border-border px-1.5 py-0.5 text-[10px] leading-none text-text-muted max-lg:hidden" aria-hidden="true">Ctrl+K</kbd>
      </template>
    </UiInput>
  </div>
</template>

<script setup lang="ts">
// Campo di ricerca del menu. Esc svuota (senza chiudere il pannello se c'è del testo), Invio emette `invio`; Ctrl+K lo mette a fuoco
// (la scorciatoia la gestisce la sidebar).
import { useI18n } from "vue-i18n";

const testo = defineModel<string>({ default: "" });
const emit = defineEmits<{ invio: [] }>();
const { t } = useI18n();
const campo = ref<{ focus: () => void } | null>(null);

defineExpose({ focus: () => campo.value?.focus() });
</script>
